import React from 'react'
import { TranslationKeys } from 'locales/translationKeys'
import { Text } from 'components/Text'
import useTranslation from 'next-translate/useTranslation'
import { ParagraphAndList } from '../ParagraphAndList'
import { linkObject } from '../../PrivacyPolicy'

export type CollapsibleContentSectionProps = {
  number?: string
  title?: TranslationKeys
  paragraphsAndLists?: {
    paragraphs?: TranslationKeys[]
    lists?: TranslationKeys[]
    orderedLists?: TranslationKeys[]
    links?: linkObject[]
  }[]
  nestingLevel?: number
}

export const CollapsibleContentSection = ({
  number,
  title,
  paragraphsAndLists,
  nestingLevel = 0,
}: CollapsibleContentSectionProps) => {
  const { t } = useTranslation()

  return (
    <>
      {title && (
        <Text weight="bold" css={{ paddingLeft: `${nestingLevel * 24}px` }}>
          {number} {t(title)}
        </Text>
      )}
      {paragraphsAndLists &&
        paragraphsAndLists?.map(({ paragraphs, lists, orderedLists, links }, index) => (
          <ParagraphAndList
            nestingLevel={nestingLevel}
            paragraphs={paragraphs}
            list={lists}
            orderedList={orderedLists}
            links={links}
            key={index}
          />
        ))}
    </>
  )
}

CollapsibleContentSection.displayName = 'CollapsibleContentSection'
